import React from "react";
import styles from "./Switch.module.css";

interface SwitchProps {
    value: boolean;
    onChange: (isOn: boolean) => void;
}

const Switch: React.FC<SwitchProps> = ({ value, onChange }) => {
    const toggleSwitch = () => {
        const newIsOn = !value;
        if (onChange) {
            onChange(newIsOn);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggleSwitch();
        }
    };

    return (
        <div
            role="switch"
            aria-checked={value}
            aria-label="Toggle setting"
            tabIndex={0}
            className={`${styles.switch} ${value ? styles.switchOn : ""}`}
            onClick={toggleSwitch}
            onKeyDown={handleKeyDown}
        >
            <div className={`${styles.switchHandle} ${value ? styles.switchHandleOn : ""}`} />
        </div>
    );
};

export default Switch;
